module.exports = __webpack_public_path__ + "img/posada_invitacion.9cb5f17e.jpg";